import type { ComponentCategory } from './component-registry.js';

/** Human-readable labels for component registry categories. */
export const CATEGORY_LABELS: Record<ComponentCategory, string> = {
  typography: 'Typography',
  inputs: 'Inputs',
  'data-display': 'Data display',
  feedback: 'Feedback',
  surfaces: 'Surfaces',
  navigation: 'Navigation',
  layout: 'Layout',
};

/** Short descriptions shown on the all-components page section headers. */
export const CATEGORY_DESCRIPTIONS: Record<ComponentCategory, string> = {
  typography: 'Type primitives for headings and body copy, including the brand display scale.',
  inputs: 'Form controls and interactive elements that collect user input.',
  'data-display':
    'Components for presenting labels, lists, tables, and other read-only information.',
  feedback:
    'Alerts, confirmations, toasts, and progress indicators that communicate system status.',
  surfaces: 'Containers and overlays that group content — cards, dialogs, and accordions.',
  navigation: 'Wayfinding controls — tabs, breadcrumbs, and dropdown menus.',
  layout: 'Box, flex, grid, and section primitives for composing page structure.',
};

/** Display order for category sections on the all-components page and sidebar. */
export const CATEGORY_ORDER: ComponentCategory[] = [
  'typography',
  'inputs',
  'data-display',
  'feedback',
  'surfaces',
  'navigation',
  'layout',
];

/** Short badge labels on component catalog cards. */
export const CATEGORY_BADGE_LABELS: Record<ComponentCategory, string> = {
  typography: 'Type',
  inputs: 'Input',
  'data-display': 'Display',
  feedback: 'Feedback',
  surfaces: 'Surface',
  navigation: 'Nav',
  layout: 'Layout',
};

/** Decorative icons shown in category section headers. */
export const CATEGORY_ICONS: Record<ComponentCategory, string> = {
  typography: 'Aa',
  inputs: '⌨',
  'data-display': '◆',
  feedback: '!',
  surfaces: '▢',
  navigation: '→',
  layout: '⬚',
};

/** `data-category` value used for scoped CSS tokens and styling hooks. */
export function categoryDataAttr(category: ComponentCategory): string {
  return category;
}
